import React from 'react';
import { PublicLayout } from '@/components/Layout/PublicLayout';

export const ReturnPolicyPage: React.FC = () => {
  return (
    <PublicLayout
      title="Cancellation, Returns & Refund Policy"
    >
      <div className="space-y-6 text-sm sm:text-base text-slate-700 leading-relaxed">
        
        {/* Section 1 */}
        <section className="space-y-2">
          <h3 className="text-base sm:text-lg font-bold text-slate-900">
            1. Cancelling an Order
          </h3>
          <p>
            Customers may request cancellation before an order has been processed, prepared or dispatched. Once an order has entered preparation or delivery, cancellation may no longer be possible.
          </p>
        </section>

        {/* Section 2 */}
        <section className="space-y-2">
          <h3 className="text-base sm:text-lg font-bold text-slate-900">
            2. Damaged or Broken Products
          </h3>
          <p>
            If eggs or other products arrive damaged or broken, report the issue as soon as reasonably possible and provide photographs if requested. Yebo Eggs will assess the complaint and may provide a replacement, refund or other appropriate remedy.
          </p>
        </section>

        {/* Section 3 */}
        <section className="space-y-2">
          <h3 className="text-base sm:text-lg font-bold text-slate-900">
            3. Incorrect Products
          </h3>
          <p>
            If you receive the wrong product or quantity, contact Yebo Eggs as soon as possible. We will assess the issue and arrange an appropriate remedy where applicable.
          </p>
        </section>

        {/* Section 4 */}
        <section className="space-y-2">
          <h3 className="text-base sm:text-lg font-bold text-slate-900">
            4. Poor Quality Products
          </h3>
          <p>
            If a product is defective, spoiled, unsafe or otherwise does not meet applicable quality requirements, report the issue promptly. Yebo Eggs will assess the complaint and provide an appropriate remedy where required by law.
          </p>
        </section>

        {/* Section 5 */}
        <section className="space-y-2">
          <h3 className="text-base sm:text-lg font-bold text-slate-900">
            5. Change of Mind
          </h3>
          <p>
            Because eggs, poultry and other food products may be perishable, returns based only on a change of mind may not be accepted where the nature of the product makes a return inappropriate. This does not affect mandatory consumer rights.
          </p>
        </section>

        {/* Section 6 */}
        <section className="space-y-2">
          <h3 className="text-base sm:text-lg font-bold text-slate-900">
            6. Refunds
          </h3>
          <p>
            Where a refund is approved, Yebo Eggs will generally process it using the original payment method where reasonably possible. The time for funds to appear may depend on the customer's bank or payment provider.
          </p>
        </section>

        {/* Section 7 */}
        <section className="space-y-2">
          <h3 className="text-base sm:text-lg font-bold text-slate-900">
            7. Unavailable Products
          </h3>
          <p>
            If Yebo Eggs cannot fulfil a product already paid for, we may offer an alternative product, partial fulfilment or a refund, as applicable.
          </p>
        </section>

      </div>
    </PublicLayout>
  );
};
